<template  >
  <div id="app">
    <div id="top" class="shadow-down" v-show="islogin">
      <div class="container">
        <div class="logo">
          <a href="https://www.wuliangye.com.cn/">
            <img src="./assets/logo.svg" />
          </a>
        </div>

        <div v-if="isLoggedIn" class="commont_right">
          <div style="height:100%">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                {{user}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" style="margin-top:-15px">
                <el-dropdown-item command="a">我的简历</el-dropdown-item>
                <el-dropdown-item command="b">我的申请</el-dropdown-item>
                <el-dropdown-item command="c">退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- <el-link @click="$router.push('/personal/center')" :underline="false" style="display: inline-block;font-size: 15px;">个人中心</el-link>
          <el-link @click="out()" :underline="false" style="margin-left:10px;display: inline-block;font-size: 15px;">退出</el-link> -->
        </div>
        <div v-else class="commont_right">
          <el-link @click="$router.push('/login')" :underline="false" style="display: inline-block;font-size: 14px;">登录</el-link>
          <el-divider direction="vertical"></el-divider>
          <el-link @click="$router.push('/register')" :underline="false" style="display: inline-block;font-size: 14px;">注册</el-link>
        </div>

        <el-menu class="menuItem" mode="horizontal" text-color="#333" active-text-color="red" style="float:right;block;" :collapse="false" :router="true" :default-active="hadleDefaultActive" border>
          <el-menu-item index="/home">首页</el-menu-item>
          <el-menu-item index="/announcement">公告公示</el-menu-item>
          <el-menu-item index="/social">社会招聘</el-menu-item>
          <el-menu-item index="/campus">校园招聘</el-menu-item>
          <el-menu-item index="/internship">实习生招聘</el-menu-item>
          <el-menu-item index="/internal">内部招聘</el-menu-item>
          <el-menu-item index="null" v-if="false"></el-menu-item>
        </el-menu>
      </div>
    </div>
    <!-- ------------------ -->
    <router-view style="margin-top: 72px; min-width: 1000px"></router-view>
    <!------------五粮液尾部版权------------->
    <div class="bottomBg" v-show="islogin">
      <div class="mainContainer">
        <div class="copy">
          <span>© 2018五粮液公司版权所有</span>
          <span>蜀ICP备10204898号</span>
          <span>川公网安备51150202000113号</span>
          <img src="./assets/gslogo.png" />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";

export default {
  name: "App",
  data() {
    return {
      isLoggedIn: false,
    }
  },
  computed: {
    user() {
      let reg = /^(1[3-9][0-9])\d{4}(\d{4}$)/; // 定义手机号正则表达式
      let phone = sessionStorage.getItem('user').replace(reg, '$1****$2');
      return phone; // 输出为131****1234
    },
    islogin() {
      let path = this.$route.path + "";
      if (path.startsWith("/login") || path.startsWith("/register") || path.startsWith("/changePass")) {
        return false
      } else {
        return true
      }
    },
    hadleDefaultActive() {
      var ret = " ";
      var pa = this.$route.path + "";
      if (pa.startsWith("/home")) {
        ret = "/home";
      } else if (pa.startsWith("/announcement")) {
        ret = "/announcement";
      } else if (pa.startsWith("/internship")) {
        ret = "/internship";
      } else if (pa.startsWith("/campus")) {
        ret = "/campus";
      } else if (pa.startsWith("/social")) {
        ret = "/social";
      } else if (pa.startsWith("/internal")) {
        ret = "/internal";
      } else {
        ret = "/null";
      }
      return ret;
    },
  },
  mounted() {
    if (sessionStorage.getItem('user') && sessionStorage.getItem('user') != 'undefined') {
      this.isLoggedIn = true
    }
    let _this = this;
    window.addEventListener("setItemEvent", function (e) {
      if (e.key === "user") {
        console.log(e.newValue);
        _this.isLoggedIn = !!e.newValue;
      }
    })
    Date.prototype.format = function (fmt) {
      var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (this.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    };

    //1.处理日期对象json化后差 8小时的问题。
    Date.prototype.toJSON = function () {
      return this.format("yyyy-MM-ddThh:mm:ss");
    };

    //2.访问人数统计
    axios
      .create({
        baseURL: "/zhaopin/visit_count/count",
        timeout: 3000,
      })
      .get();
  },
  methods: {
    handleCommand(command) {
      if (command == 'a') {
        this.$router.push({
          path: '/personal/center',
          query: {
            activeName: 'first'
          }
        })
      } else if (command == 'b') {
        this.$router.push({
          path: '/personal/center',
          query: {
            activeName: 'second'
          }
        })
      } else if (command == 'c') {
        this.out()
      }
    },
    out() {
      sessionStorage.setItem('user', void 0)
      this.$router.push('/')
      location.reload();
    },
  },
};
</script>

<style scoped>
.commont_right {
  float: right;
  width: 200px;
  height: 100%;
  display: inline-block;
  line-height: 68px;
  font-size: 15px;
}

.logo {
  left: 2vw;
  transition: all 0.3s;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}

a:link,
a:visited,
a:hover,
a:active {
  color: #404040;
  text-decoration: none;
}
*,
*:after,
*:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.shadow-down {
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#000000,direction=120,strength=10); /*ie*/
  -moz-box-shadow: 1px 1px 10px #cacaca; /*firefox*/
  -webkit-box-shadow: 1px 1px 10px #cacaca; /*safari或chrome*/
  /* box-shadow:1px 1px 10px #cacaca; */ /*opera或ie9*/
}

#top {
  width: 100%;
  left: 0;
  top: 0;
  height: 72px;
  margin: 0;
  padding: 0;
  z-index: 100;
  transition: all 0.3s;
  position: fixed;
  background: #fff;
}
#top .container {
  width: 100%;
  min-width: 1000px;
  max-width: 1520px;
  height: 100%;
  text-align: center;
  margin: 0 auto;
  padding: 0 2vw;
  position: relative;
  background: #fff;
}
#top .logo {
  position: absolute;
  left: 2vw;
  top: 50%;
  transform: translate(0, -50%);
  transition: all 0.3s;
  background: #fff;
}
#top .logo img {
  width: 150px;
  height: auto;
  background: #fff;
}

.el-menu {
  border-bottom: 0px;
  border-bottom-width: 0;
  background: #fff;
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none;
}

.el-menu--horizontal .el-menu-item {
  border-bottom: 0px;
  height: 72px;
  line-height: 72px;
  font-size: 15px;
  display: block;
  box-sizing: border-box;
  padding: 0 1.8vw;
  margin: 0;
  text-align: center;
}

.el-menu--horizontal .el-menu-item :hover {
  outline: 0 !important;
  color: #df0716 !important;
  transition: all 0.3s;
}

.el-menu--horizontal .is-active {
  color: #fff !important;
  background: #df0716 !important;
  border: 0px;
  box-shadow: 0 0 10px #c1000d;
  text-decoration: none;
  transition: all 0.3s;
  border-bottom: 0px;
}

.menuItem {
  opacity: 1;
  visibility: visible;
  list-style-type: none;
}

/**----------五粮液尾部版权----------- */

.bottomBg {
  min-width: 1000px;
  background: #3e3e3e;
  padding: 20px 0 0 0;
}

.mainContainer {
  width: 70%;
  min-width: 1000px;
  max-width: 1520px;
  text-align: center;
  margin: 0 auto;
}
.copy {
  padding: 5px 0;
}
.copy span {
  padding: 0 3px;
  color: hsla(0, 0%, 100%, 0.6);
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
.copy img {
  vertical-align: middle;
}
</style>

<style>
/* 要覆盖的样式 */
.el-date-editor.el-input {
  width: 250px;
}
.el-card {
  margin-bottom: 10px;
}

.el-dialog__header {
  padding: 0px;
}

.el-input.is-disabled .el-input__inner {
  color: #606266;
  cursor: default;
}

.el-select .el-input.is-disabled .el-input__inner {
  cursor: default;
}

.el-textarea__inner {
  font-family: Arial;
}
.el-popup-parent--hidden{
  padding: 0 !important;
}

.el-checkbox{
  margin-right: 20px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue